import React from 'react';
import MetricTiles from 'app/components/metricTiles/MetricTiles';
import MetricTile from 'app/components/metricTiles/MetricTile';
import {parseNumber, round} from 'app/helpers/helpers';
import {object, bool} from 'prop-types';

export const CompetitionRankingsContent = ({stats}) => {
  const statsLoaded = stats && stats.matches;

  const facts = [
    [statsLoaded && stats.goals ? round(stats.goals / stats.matches, 1) : '–', 'Tore/Spiel'],
    [statsLoaded && stats.avgSpectators ? parseNumber(stats.avgSpectators) : '–', 'Zuschauer/Spiel'],
    [statsLoaded && stats.penaltyTotal ? round(stats.penaltyTotal / stats.matches, 1) : '–', 'Elfmeter/Spiel'],
    [statsLoaded && stats.yellowCards ? round(stats.yellowCards / stats.matches, 2) : '–', 'Gelb/Spiel'],
    [statsLoaded && stats.yellowRedCards ? round(stats.yellowRedCards / stats.matches, 2) : '–', 'Gelb-Rot/Spiel'],
    [statsLoaded && stats.redCards ? round(stats.redCards / stats.matches, 2) : '–', 'Rot/Spiel'],
  ];
  const topFacts = facts.map((fact, index) => (
    <MetricTile key={fact[1]} value={fact[0]} label={fact[1]} index={index} />
  ));
  return <MetricTiles>{topFacts}</MetricTiles>;
};

CompetitionRankingsContent.propTypes = {
  stats: object,
  isFetching: bool,
};
